import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["language"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { memo, useMemo, useCallback, useState, useContext, useRef, useEffect } from 'react';
import { useWeb5Context } from "../../../../lib/Web5Context";
import { publish } from "../../../../lib/EventBuser";
import { REFRESH_IMPORT_AFTER_CREATE_FIELD } from "../../../../lib/events";
import { LOGEVENT_SUBMODULE } from "../../../Fields/constants";
import FormExtraField from "../../../Fields/FormExtraField";
import { getMappedFieldList } from "../../../Fields/lib";
import { getEntityFromString } from "../../../../utils/getEntityFromString";
import ImportContext from "../../ImportContext";
const CreateFieldModal = /*#__PURE__*/memo(_ref => {
  let {
    formExtraFieldRef,
    setFormExtraFieldRef,
    idSetupRole,
    entityName
  } = _ref;
  const [fieldsData, setFieldsData] = useState(null);
  const isFirstRender = useRef(true);
  const {
    t,
    language: lang,
    setDeviceCache,
    customGeneralTab,
    logEvent
  } = useWeb5Context();
  const _useContext = useContext(ImportContext),
    {
      language: externalLanguage
    } = _useContext,
    overrides = _objectWithoutProperties(_useContext, _excluded);
  const language = externalLanguage || lang;
  const entityLogProps = useMemo(() => {
    const entity = getEntityFromString(entityName);
    const entityField = (entity === null || entity === void 0 ? void 0 : entity.fields) || entityName;
    const submodule = LOGEVENT_SUBMODULE[entityField];
    return {
      entityLogName: 'fields',
      entityLogSubmodule: submodule
    };
  }, [entityName]);
  const getEntityData = useCallback(entity => {
    return new Promise((resolve, reject) => {
      getMappedFieldList(entity, language, t, customGeneralTab).then(data => {
        if (!data) {
          reject();
        } else {
          setFieldsData(_objectSpread(_objectSpread({}, fieldsData), {}, {
            [entity]: data
          }));
          resolve(data);
        }
      }).catch(reject);
    });
  }, [language, customGeneralTab, t, fieldsData]);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      const entity = getEntityFromString(entityName);
      getEntityData((entity === null || entity === void 0 ? void 0 : entity.fields) || entityName);
    }
  }, [getEntityData, entityName]);
  const processDataBeforeSave = useCallback(data => {
    var _Object$keys;
    if (!data || ((_Object$keys = Object.keys(data)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0) return data;
    return Object.entries(data).reduce((obj, _ref2) => {
      let [key, value] = _ref2;
      if (key === 'customValidation' && !value) {
        obj[key] = -1;
      } else {
        obj[key] = value;
      }
      return obj;
    }, {});
  }, []);
  const refreshList = useCallback(_ref3 => {
    let {
      response,
      rowIndex
    } = _ref3;
    const createdField = response !== null && response !== void 0 && response.data ? response.data : null;
    if (!createdField) return;
    logEvent({
      event: 'settings',
      submodule: 'import',
      functionality: 'createField'
    });
    publish(REFRESH_IMPORT_AFTER_CREATE_FIELD, {
      field: createdField,
      rowIndex
    });
  }, [logEvent]);
  if (!fieldsData) return;
  return /*#__PURE__*/React.createElement(FormExtraField, _extends({
    onRef: ref => {
      !formExtraFieldRef && setFormExtraFieldRef(ref);
    },
    setDeviceCache: setDeviceCache,
    fieldsData: fieldsData,
    getEntityData: getEntityData,
    idSetupRole: idSetupRole,
    processDataBeforeSave: processDataBeforeSave
  }, entityLogProps, {
    avoidTours: true,
    overrides: overrides,
    refreshList: refreshList
  }));
});
export default CreateFieldModal;